<template>
    <div class="swipe-warper">
        <van-swipe v-if="showCang" :autoplay="3000" :height="150">
            <van-swipe-item  v-for="(image, index) in imagesCang" :key="index" >
                <van-image radius="10" height="150" :src="image" />
            </van-swipe-item>
        </van-swipe>

        <van-swipe v-if="showProcess" :autoplay="3000" :height="150">
            <van-swipe-item  v-for="(image, index) in imagesProcess" :key="index" >
                <van-image radius="10" height="150" :src="image" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { Swipe, SwipeItem } from 'vant';
    import {Lazyload} from 'vant';
    import { Image as VanImage } from 'vant';
    Vue.use(Lazyload)
    export default {
        name: "SwipeImage",
        components:{
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            [VanImage.name]: VanImage,

        },
        mounted() {
            let systemId = localStorage.getItem('systemId')
            if (systemId == 10) {
                // 仓库
                this.showCang = true
            } else if (systemId == 15) {
                // 加工
                this.showProcess = true
            }
        },
        data() {
            return {
                showCang:false,
                showProcess:false,
                lazyComponent: true,
                imagesCang: [
                    'https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/20201017103145.png',

                ],
                imagesProcess: [
                    'https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/20210817144131.jpg'

                ],


            };
        },
    }
</script>

<style scoped>
    .swipe-warper{
        width:95%;
        margin:10px auto 0 auto;
    }
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }

    van-swipe{
        height: 150px;
    }
</style>